import { render } from "./MappaturaPiatti.vue?vue&type=template&id=5a13fa6e&scoped=true"
import script from "./MappaturaPiatti.vue?vue&type=script&lang=js"
export * from "./MappaturaPiatti.vue?vue&type=script&lang=js"

import "./MappaturaPiatti.vue?vue&type=style&index=0&id=5a13fa6e&scoped=true&lang=css"

import exportComponent from "/root/frontTioPizza/mymenucli/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a13fa6e"]])

export default __exports__